/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Button from "../Button";
import Modal, { ModalHeader } from "../Modal";
import { ControlTable } from "../Table";
import {
  getManagerCompanyEmployees,
} from "../../apis/companies/roles";
import { get, isEmpty } from "lodash";
import { viewLoading } from "../../utils/loading";
import { getStoreCompanies } from "../../store/actions";
import { useDispatch } from "react-redux";
import systemAlert from "../../utils/systemAlert";
import { deleteCareCompany } from "../../apis/companies/companies";
import { COMPANY_MANAGER_LEVEL } from "../../constants/COMPANY";
import Filters from "../Filters";
import useForm from "../../hooks/useForm";
import { toast } from "../../utils/toast";
import { modeifyTaxpayerManagers } from "../../apis/tax-portal/taxpayer";
import Radios from "../Radio/Radios";

const TaxpayerManager = ({
  type = 2,
  open,
  setOpen,
  list,
  taxpayerList,
  setTaxpayerList,
  submit: _submit = () => { },
}) => {
  const dispatch = useDispatch();
  const [comFields] = useState([
    { title: "회사명", key: "name" },
    { title: "대표명", key: "ceoName" },
    { title: "사업자번호", key: "comNum" },
  ]);
  const [employeeFields, setEmployeeFields] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState({});
  const [manageComEmployees, setManageComEmployees] = useState([]);
  const [step, setStep] = useState(0);
  const [managers, setManagers] = useState([]);
  const [selectedCompanyIdx, setSelectedCompanyIdx] = useState(-1);
  const [viewList, setViewList] = useState(list);
  const [filter] = useState([
    {
      title: "상호",
      key: "name",
      options: {
        placeholder: "검색어 입력",
      },
    },
    {
      title: "대표이름",
      key: "ceoName",
      options: {
        placeholder: "검색어 입력",
      },
    },
  ]);

  const { form, filterSubmit, setSubmit, handleOnChange } = useForm();

  useEffect(() => {
    setViewList(list);
  }, [list]);

  const _filterSubmit = ({ name, ceoName }) => {
    let resultList = list;
    if (name) {
      resultList = resultList.filter(f => f.name.includes(name));
    }

    if (ceoName) {
      resultList = resultList.filter(f => f.ceoName.includes(ceoName));
    }

    setViewList(resultList);
  };
  useEffect(() => {
    !isEmpty(list) && setSubmit(_filterSubmit);
  }, [list]);

  const submit = () => {
    setTimeout(() => {
      _submit();
    }, 500);
  };

  const cancel = () => {
    setOpen(false);
    reset();
    setTaxpayerList && setTaxpayerList([]);
  };

  useEffect(() => {
    if (!isEmpty(list)) {
      setSelectedCompanyIdx(0);
      setSelectedCompany(list[0]);
    }
  }, [list]);

  useEffect(() => {
    setEmployeeFields([
      { title: "직원명", key: "name" },
      { title: "직원코드", key: "code" },
      {
        title: "담당권한",
        type: "component",
        key: "level",
        component: ({ data }) => {
          return (
            <Radios
              name="level"
              field={{
                options: { list: COMPANY_MANAGER_LEVEL },
                key: `employee-${data.idx}-level`,
                defaultChecked: managers.find(f => f.managerIdx === data.idx)?.level,
                onChange: (e) => {
                  const _managers = manageComEmployees.map(employee => {
                    const findManager = managers.find(f => f.managerIdx === employee.idx);
                    const isChangeLevel = data.idx === employee.idx;
                    let level = isChangeLevel ? e.target.value : findManager?.level;
                    return {
                      managerIdx: employee.idx,
                      level: COMPANY_MANAGER_LEVEL.find(f => f.value === level)?.value || "0"
                    };
                  });
                  setManagers(_managers);
                }
              }}
            />
          );
        },
      },
      { title: "입사일", key: "joinDate" },
    ]);

  }, [managers]);

  const getPageTitle = () => {
    let title = "";
    switch (type) {
      case 2:
        title = "세무 기업 목록";
        break;
      case 3:
        title = "노무 기업 목록";
        break;
      case 9:
        title = "경리대행 기업 목록";
        break;
      default:
        break;
    }
    return title;
  };

  const handleNextStep = () => {
    if (isEmpty(selectedCompany)) return;

    setStep(1);
    getManagerCompanyEmployees(selectedCompany.idx || selectedCompany.companyIdx).then((res) => {
      const manageComEmployees = get(res, "data.employees", []);
      setManageComEmployees(manageComEmployees);
      const _managers = manageComEmployees.map(item => {
        let level = item?.companyManagerPerson?.level > 0 ? `${item?.companyManagerPerson?.level?.level}` : "0";
        return {
          managerIdx: item.idx,
          level
        };
      });

      setManagers(_managers);

    });
  };

  const handleSumbit = () => {
    viewLoading("매니저 설정중입니다.");
    const form = {
      type,
      managerComIdx: selectedCompany.idx || selectedCompany.companyIdx,
      managers: managers.filter(f => f.level !== "0").map(item => ({ ...item, level: +item.level })),
      taxpayerIdxes: taxpayerList.map(item => item.idx)
    };

    modeifyTaxpayerManagers(form)
      .then(() => {
        toast.success('수정이 완료되었습니다.');
        cancel();
        submit();
      })
      .catch(() => { })
      .finally(() => {
        viewLoading(false);
        dispatch(getStoreCompanies());
      });
  };

  const reset = () => {
    setSelectedCompany({});
    setManageComEmployees([]);
    setManagers([]);
    setStep(0);
  };


  const handleDelete = () => {
    const companyIdx = taxpayerList.companyIdx || taxpayerList.idx;

    systemAlert(`"${taxpayerList.name}"회사의 관리를 해제 하시겠습니까?`, {
      buttons: [
        {
          color: 'text',
          label: '취소',
        },
        {
          color: 'red',
          label: '관리해제',
          onClick: () => {
            viewLoading(true);
            deleteCareCompany(
              companyIdx,
              { type },
              `"${taxpayerList.name}"회사의 관리가 해제되었습니다.`
            ).then(res => {
              if (res.status === 200) {
                cancel();
                submit();
              }
            }).finally(() => viewLoading(false));
          }
        }
      ]
    });
  };

  return (
    <Modal isOpen={open} close={cancel}>
      <div className="manager-company-write">
        {step === 0 && (
          <div className="manager-company-first-step">
            <ModalHeader>{getPageTitle()}</ModalHeader>
            <Filters
              filters={filter}
              submit={filterSubmit}
              onChange={handleOnChange}
              form={form}
            />
            {!isEmpty(viewList) && (
              <ControlTable
                fields={comFields}
                list={viewList}
                isSelect={{ defaultChecked: selectedCompanyIdx }}
                setSelectedData={setSelectedCompany}
              />
            )}
            <div className="control-button-wrap clear">

              <Button
                className="button"
                label="다음"
                disabled={isEmpty(selectedCompany)}
                onClick={handleNextStep}
              />
              <Button
                className="button"
                color="text"
                label="취소"
                onClick={cancel}
              />
              <Button
                className="button float-left"
                label="관리해제"
                onClick={handleDelete}
                color={"red"}
                disabled={type !== 2 && type !== 9}
              />
            </div>
          </div>
        )}
        {step === 1 && (
          <div className="manager-company-second-step">
            <ModalHeader>{`${selectedCompany.name} 직원 목록`}</ModalHeader>
            <ControlTable
              fields={employeeFields}
              list={manageComEmployees}
            />
            <div className="control-button-wrap">
              <Button
                className="button"
                label="확인"
                disabled={isEmpty(managers.find(f => f.level === "2" || f.level === "1"))}
                onClick={handleSumbit}
              />
              <Button
                className="button"
                color="text"
                label="취소"
                onClick={cancel}
              />
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default TaxpayerManager;
